import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
	selector: 'app-configurator-component',
	templateUrl: './configurator.component.html',
	styleUrls: ['./configurator.component.scss'],
	changeDetection: ChangeDetectionStrategy.Eager,
	standalone: false,
})
export class ConfiguratorComponent {
	public constructor() {}
}
